import React, { Suspense } from 'react'
import ReactDOM from 'react-dom/client'

import reportWebVitals from './reportWebVitals'
import { BrowserRouter } from 'react-router-dom'
import { Provider } from 'react-redux'

import PageonLoad from '@/components/pageonLoad'

import App from '@/App'
import store from './store'
import 'normalize.css'
import '@/assets/css/index.less'
import theme from './assets/theme'
import { ThemeProvider } from 'styled-components'
import { ConfigProvider } from 'antd'

const root = ReactDOM.createRoot(
  document.getElementById('tianwawa_app') as HTMLElement
)

root.render(
  <Suspense fallback={<PageonLoad />}>
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: '#1EAB73'
        }
      }}
    >
      <Provider store={store}>
        <ThemeProvider theme={theme}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </ThemeProvider>
      </Provider>
    </ConfigProvider>
  </Suspense>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
